module.exports = __webpack_public_path__ + "static/media/hatchbackLight.dfac3008.svg";